import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['settings', 'user'])
}



// WEBPACK FOOTER //
// ./src/app/patient/config/resources/computed.js